<template>
  <div class="h-100 d-flex align-items-center">
    <input
      v-if="isRenaming"
      ref="inputRef"
      v-model="titleValue"
      class="w-100 form-control form-control-sm"
      @keyup.enter.stop="confirmTitleValue"
      @keydown.esc.stop=""
      @keyup.esc.stop="toggleIsRenaming(false)"
      @click.stop=""
    />

    <tippy-tooltip
      v-else
      :content="teamAsset.title"
      tag="div"
      class="w-100"
    >
      <h5
        ref="titleRef"
        class="mb-0 text-center font-size-xs font-weight-bolder text-truncate mt-2"
        @click.stop="toggleIsRenaming(true)"
      >
        {{ teamAsset.title }}
      </h5>
    </tippy-tooltip>
  </div>
</template>

<script>
import { watch, ref, nextTick } from 'vue'
import { templateRef } from '@vueuse/core'
import { useTeamAssetItem } from './use-team-asset-item'
import { useTeamAssets } from './use-team-assets'
import TippyTooltip from '../tippy-tooltip.vue'

export default {
  name: 'TeamAssetItemTitle',
  components: { TippyTooltip },
  setup () {
    const inputRef = templateRef('inputRef')
    const titleValue = ref('')

    const { updateTeamAsset } = useTeamAssets()
    const { teamAsset, isRenaming, toggleIsRenaming } = useTeamAssetItem()

    watch(isRenaming, (value) => {
      if (value) {
        titleValue.value = teamAsset.value.title
        nextTick(() => {
          inputRef.value.focus()
          inputRef.value.select()
        })
      }
    })

    const confirmTitleValue = async () => {
      await updateTeamAsset(teamAsset.value, { title: titleValue.value })

      toggleIsRenaming(false)
    }

    return {
      teamAsset,

      titleValue,

      isRenaming,
      toggleIsRenaming,

      confirmTitleValue
    }
  }
}
</script>
